import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { CartProvider } from "@/context/CartContext";
import { ConsentProvider } from "@/context/ConsentContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import ConsentBanner from "@/components/ConsentBanner";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import SearchConsoleMeta from "@/components/SearchConsoleMeta";
import HomePage from "@/pages/HomePage";
import RecipesPage from "@/pages/RecipesPage";
import RecipeDetailPage from "@/pages/RecipeDetailPage";
import ShopPage from "@/pages/ShopPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AuthPage from "@/pages/AuthPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ProfilePage from "@/pages/ProfilePage";
import SubmitRecipePage from "@/pages/SubmitRecipePage";
import SelectionPage from "@/pages/SelectionPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import AdminRecipesPage from "@/pages/AdminRecipesPage";
import ReferralPage from "@/pages/ReferralPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import AuthCallback from "@/pages/AuthCallback";
import ReferralBanner from "@/components/ReferralBanner";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import CGV from "@/pages/legal/CGV";
import Confidentialite from "@/pages/legal/Confidentialite";
import Livraison from "@/pages/legal/Livraison";
import Retours from "@/pages/legal/Retours";
import Contact from "@/pages/legal/Contact";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle Emergent OAuth callback before normal routes
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <SearchConsoleMeta />
      <AnalyticsTracker />
      <ReferralBanner />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recipes" element={<RecipesPage />} />
          <Route path="/recipes/:slug" element={<RecipeDetailPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/:slug" element={<ProductDetailPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/submit" element={<SubmitRecipePage />} />
          <Route path="/submit/:recipeId" element={<SubmitRecipePage />} />
          <Route path="/selections/:slug" element={<SelectionPage />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/admin/leads" element={<AdminLeadsPage />} />
          <Route path="/admin/recipes" element={<AdminRecipesPage />} />
          <Route path="/legal/mentions" element={<MentionsLegales />} />
          <Route path="/legal/cgv" element={<CGV />} />
          <Route path="/legal/confidentialite" element={<Confidentialite />} />
          <Route path="/legal/livraison" element={<Livraison />} />
          <Route path="/legal/retours" element={<Retours />} />
          <Route path="/legal/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <ConsentBanner />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <LangProvider>
        <ConsentProvider>
          <AuthProvider>
            <CartProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </CartProvider>
          </AuthProvider>
        </ConsentProvider>
      </LangProvider>
    </div>
  );
}
